/* ============================================================================
   LAH — O SELO DE DESCONTO AO LADO DO NOME (barra de compra, celular)
   Tema: Testes de implementacao (8.0)

   ============================================================================
   POR QUE ISSO E JAVASCRIPT E NAO CSS
   ============================================================================
   O selo nasce dentro da linha de preco, depois do valor. Queremos ele ao lado
   do NOME, que esta noutra linha — e CSS nao move elemento entre containers.

   Move-lo por script e o caminho menos invasivo: o markup vive em
   custom-main-product.liquid, um arquivo de 40 KB no coracao da pagina de
   compra, e editar la para trocar um elemento de lugar nao compensa o risco.

   O ALPINE CONTINUA MANDANDO NO SELO. Ele guarda a referencia ao elemento, nao
   ao lugar dele: mudar de pai nao quebra o x-show nem o x-text. O selo
   continua aparecendo so quando ha desconto e continua calculando a
   porcentagem sozinho.

   Fazemos isso UMA VEZ, no carregamento. O elemento nao e recriado — o Alpine
   apenas liga e desliga a exibicao dele.
   ============================================================================ */

(function () {
    'use strict';

    /* A barra so existe no celular. */
    if (!window.matchMedia('(max-width: 999px)').matches) return;

    var tentativas = 0;

    (function mover() {
        var nome = document.querySelector('.lah-purchase-dock__name');
        var selo = document.querySelector('.lah-purchase-dock__badge');

        /* A barra e montada pelo Alpine e pode nao existir ainda. */
        if (!nome || !selo) {
            tentativas++;
            if (tentativas > 30) return;
            setTimeout(mover, 150);
            return;
        }

        /* Ja movido (navegacao instantanea pode reexecutar o script). */
        if (nome.parentNode.classList.contains('lah-purchase-dock__titulo')) return;

        var linha = document.createElement('span');
        linha.className = 'lah-purchase-dock__titulo';

        nome.parentNode.insertBefore(linha, nome);
        linha.appendChild(nome);
        linha.appendChild(selo);
    })();
})();
